
  import { Component, Vue ,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  
  import {
    productCategory,
    productpopoverproductlist
  } from '@/api/supplier'
  
	import {
    getSearchDate,
		nextDay
	} from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:{}}) msg!:any
    private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private keywords = ''
    private filterTime = [getSearchDate(2,false,-7)[0],getSearchDate(2,false,7)[0]].join('/')
    private classify = ''
    private classifylist:any = []
    private tablelist:any = []
    private tableloading = false
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private choosemsg:any = this.msg

    private mounted () {
      console.log(this.choosemsg)
      this.getclassifylist()
      this.gettablelist()
    }

    private returnchoosemsg(){
      return this.choosemsg
    }
    private checkchange(e,row){
      this.tablelist = this.tablelist.map(v=>{
        v.IsChoose = false
        if(v.Id==row.Id){
          v.IsChoose = true
          this.choosemsg = v
        }
        return v
      })
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
					Keywords: this.keywords,
					ProductCategoryId: this.classify,
				}
        if (this.filterTime){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        let res = await productpopoverproductlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            if(v.Id==this.choosemsg.Id){
              v.IsChoose = true
              this.choosemsg = v
            }else{
              v.IsChoose = false
            }
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private async getclassifylist() {
			let data: any = {
				Skip: 0,
				Take: 99999,
				Keywords: ''
			}
			try {
				const res: any = await productCategory(data);
        if(res.IsSuccess){
          this.classifylist = res.Result.Results.map(v=>{
            return {
              value:v.Id,
              label:v.CategoryName
            }
          })
        }
			} finally{
        //
      }
		}
  }
